module.exports = __webpack_public_path__ + "img/volvo_user_active.5b0a2d9e.svg";